import filtersOperator from '../../../manager/filters/filters-operator';
import searchOperator from '../../../manager/search/search-operator';
import sortByOperator from '../../../manager/sort-by/sort-by-operator';
import groupByOperator from "../../../manager/group-by/group-by-operator";
import Collection from "../../../data-structures/collection";

export default class DataManager {

    public module               : any
    public _masterCollection    : Collection<any>

    public _processedData       : any[] = []; //array of groups if groupBy enabled or array of items if groupBy disabled
    public _groupsMap           : any = {}; //groups map

    private lastMouseEvent      : any
    private lastDirection       : any
    private lastTargetModel     : any

    constructor(module:any) {
        this.module = module;
        this._masterCollection = new Collection<any>([]);

        this._processedData = []; //array of groups if groupBy enabled or array of items if groupBy disabled
        this._groupsMap = {}; //groups map
    }

    set collection(dataCollection:Collection<any>) {
        this._masterCollection = dataCollection;
    }

    get collection():Collection<any> {
        return this._masterCollection;
    }

    get = () => this._processedData
    // @ts-ignore
    getGroup = (id:string) => this._groupsMap[id]

    add = (model:any) => {
        this._masterCollection?.add(model);
        this._updateModule();
    }

    remove = (id:string) => {
        this._masterCollection?.remove(id);
        this._updateModule();
    }

    _getDirectionChanged = (mouseEvent:any) => {
        let direction:any = false;
        if (this.lastMouseEvent) {
            if(this.lastMouseEvent.clientY > mouseEvent.clientY)        direction = 'top';
            else if(this.lastMouseEvent.clientY < mouseEvent.clientY)   direction = 'bottom';
        }

        let res = this.lastDirection !== direction;
        this.lastMouseEvent = mouseEvent;
        this.lastDirection = direction;

        return res;
    }

    onReorderItem = (mouseEvent:any, draggedModel:any, targetModel:any, type:any) => {

        if (!this._masterCollection) return

        const isDirectionChanged = this._getDirectionChanged(mouseEvent);

        //if same target nad dnd direction is same then do nothing
        if (!isDirectionChanged && this.lastTargetModel && this.lastTargetModel.id === targetModel.id) return;

        this.lastTargetModel = targetModel;

        let items = this._masterCollection?.items.slice();

        // find dragged model and remove
        _.remove(items, (model:any)=>model.id === draggedModel.id);

        // add dragged model at target model position according type (above|below)
        // remove no items at index and add newItem at this position
        const index = _.findIndex(items, (model:any) => model.id === targetModel.id);

        switch (type) {
            case 'below':   items.splice(index+1,0,draggedModel); break;
            case 'above':
            default:        items.splice(index,0,draggedModel); break;
        }

        const orderedIds = _.map(items, model=>model.id);
        this._masterCollection.reorderByIds(orderedIds);

        this._updateModule(false);
    }

    onConfirmReorder(currentItem: any) {

        if (this.module.config.dnd.saveSortPositions) {
            const orderedIds = _.map(this._masterCollection.items, model=>model.id);
            this.module.config.dnd.saveSortPositions(orderedIds, this._masterCollection.items, currentItem);
        }
        this._updateModule();
    }

    // calculate ?
    process() {
        let items = this._masterCollection.items.slice();

        items = filtersOperator(items, this.module.filters);
        items = searchOperator(items, this.module.search.value, this.module.fields, this.module.columns);
        items = sortByOperator(items, this.module.sortBy.sortFields, this.module.fields);

        if (this.module.groupBy) {
            // items now are not array of items, but array of group objects ([{groupByValue, groupSortValue, models},...])
            items = groupByOperator(items, this.module.groupBy.value, this.module.groupBy.direction, this.module.fields);
        }

        this._processedData = items;
        this._groupsMap = {};

        // groups map is only filled if groups are enabled, otherwise we have array of items without groups
        if (this.module.groupBy) {
            _.map(this._processedData, group=>{
                this._groupsMap[group.groupByValue] = group;
            })
        }
    }

    getDataForExport(option:any) {
        let items = this._masterCollection.items.slice()

        switch(option) {
            case gd.const.exportToCSV.itemsOptions.CURRENT  :
                items = filtersOperator(items, this.module.filters)
                items = searchOperator(items, this.module.search.value, this.module.fields, this.module.columns)
                items = sortByOperator(items, this.module.sortBy.sortFields, this.module.fields)
                break

            case gd.const.exportToCSV.itemsOptions.ALL      :
            default                                         :
                // do nothing

        }

        return items
    }

    getItemsIdsForExport(option:any) {
        return _.map(this.getDataForExport(option), item=>item.id)
    }

    _updateModule(triggerDataChangedCallback = true) {
        if (triggerDataChangedCallback) this.module.onDataChanged();

        this.process();
        this.module.reRender();
    }
}
